<template>
  <div
    class="modal fade"
    id="resumeProcessModal"
    data-focus="false"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">履歷歷程</h5>
        </div>
        <div class="modal-body">
          <div class="form-group form-inline">
            <label for="">廠別：</label>
            <multiselect
              :options="factoryOptions"
              multiple
              :close-on-select="false"
              placeholder="請選擇"
              label="Name"
              track-by="Guid"
              v-model="note.FactoryTypes"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">面談職類：</label>
            <input
              type="text"
              class="form-control w-100"
              disabled
              v-model="note.Position"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">面談主管：</label>
            <input
              type="text"
              class="form-control w-100"
              disabled
              v-model="note.InterviewSupervisors"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">面談人資：</label>
            <input
              type="text"
              class="form-control w-100"
              disabled
              v-model="note.InterviewHRs"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">報到狀況：</label>
            <input
              type="text"
              class="form-control w-100"
              disabled
              v-model="note.OnBoardStatus"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">聯絡狀況：</label>
            <input
              type="text"
              class="form-control w-100"
              maxlength="200"
              v-model="note.ContactStatusRemark"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">備註：</label>
            <input
              type="text"
              class="form-control w-100"
              maxlength="200"
              v-model="note.InterviewStatusRemark"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            關閉
          </button>
          <button type="button" class="btn btn-primary" @click="saveData">儲存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";

export default {
  props: ["personData"],

  name: "ResumeNoteModal",

  data() {
    return {
      // 廠別
      factoryOptions: [],
      
      note: {
        job: "設備",
        supervisor: "系統顧問",
        hr: "Mary",
        interviewed: "未面談",
        reported: "",
        contact: "未聯絡",
      },
    };
  },

  computed: {
    ...mapGetters(["showResumeNote", "resumeSummary"]),
  },

  watch: {
    showResumeNote: function (val) {
      if (val) {
        $("#resumeProcessModal").modal("show");
      } else {
        this.opened = false;
        $("#resumeProcessModal").modal("hide");
      }
    },

    resumeSummary: function (val) {
      this.note = val;
    },
  },

  methods: {
    // 儲存
    saveData() {
      this.$api.jobManagement.putResumeSummary({
        MatchId: this.personData.MatchId,
        FactoryTypeGuids: this.note.FactoryTypes ? this.note.FactoryTypes.map(item => item.Guid) : null,
        InterviewStatusRemark: this.note.InterviewStatusRemark,
        ContactStatusRemark: this.note.ContactStatusRemark
      }).then((response) => {
        if (response.status === 200) {
          this.$store.commit("OpenResumeNoteModal", false);
          this.$notify({
            title: "成功",
            message: "編輯成功",
            type: "success",
            duration: 3500,
          });
        }
      });
    },


    // 關閉 Modal
    closeModal() {
      this.note = {};
      this.$store.commit("OpenResumeNoteModal", false);
    },

    // 取得 廠別
    getFactory() {
      this.$api.factory.getFactory().then((response) => {
        if (response.status === 200) {
          this.factoryOptions = response.data.map((item) => {
            return {
              Guid: item.Guid,
              Name: item.Name
            };
          });
          this.$emit("getFactory", response.data);
        }
      });
    }
  },

  created() {
    this.getFactory();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenResumeNoteModal", false);
  },
};
</script>
